import { getAuditTypeLabel } from '@deepguide-ai/types'

/**
 * Render an AuditCycle's audit type. Pass the framework where it's known —
 * ISO 27001 calls a THIRD_PARTY_AUDIT an "External certification".
 *
 * Thin wrapper over the shared vocabulary so this module and the server's
 * trust-center / cycle-label formatters can't drift again.
 */
export function formatAuditCycleType(
  auditType?: string | null,
  framework?: string | null,
) {
  return getAuditTypeLabel(auditType, framework) || 'Audit'
}

/**
 * Format an audit cycle's period range, or return null when either bound is
 * missing. Audit cycle periods are nullable (`DateTime?`), and
 * `new Date(null).toLocaleDateString()` renders the epoch ("1/1/1970"), so
 * callers should omit the range entirely rather than show a fake date.
 */
export function formatAuditCyclePeriod(
  periodStart?: Date | string | null,
  periodEnd?: Date | string | null,
  options?: Intl.DateTimeFormatOptions,
): string | null {
  if (!periodStart || !periodEnd) return null
  return `${new Date(periodStart).toLocaleDateString(undefined, options)} – ${new Date(periodEnd).toLocaleDateString(undefined, options)}`
}
